import React from "react";
import { APP_COLORS } from "../../constants/styles";
import { Link } from "react-router-dom";
import { getTargetFromType, useGetLink } from "../../utils/useOpenLink";
import { getDateToDisplayInArticlePage } from "../../utils/dateFunctions";

function InstantSearchModalArticleDetails({ hit, setSelectedArticle, onClickLink, colorObj }) {
    const { getLink } = useGetLink();
    return (
        <Link
            to={getLink(hit.path, hit.type, hit.language, hit.link)}
            target={getTargetFromType(hit.type, hit.link)}
            className="card-main search-card cursor-pointer block group hover:bg-primary_color"
            onMouseEnter={() => setSelectedArticle(hit)}
            style={APP_COLORS(colorObj)}
            onClick={onClickLink}
        >
            <div className="row">
                <div className="col-lg-2 col-md-2 col-sm-3 col-4">
                    <div className="img-card">
                        <img src={hit.image?.src} alt={"Search item"} />
                    </div>
                </div>
                <div className="col-lg-10 col-md-10 col-sm-9 col-8">
                    <div className="card-body">
                        <h3 className="truncate text-accent_color1 group-hover:text-accent_color4 hover:text-accent_color4 pr-2">
                            {hit.title}
                        </h3>
                        <div className="font-semibold text-accent_color3 group-hover:text-accent_color4">
                            {hit.tags && (
                                <span className="border-solid border-r border-accent_color3 mr-1 pr-1">
                                    {hit.tags}
                                </span>
                            )}
                            <span>{getDateToDisplayInArticlePage(hit.post_date)}</span>
                        </div>
                        <div
                            className="arrow-icon-main"
                            onClick={() => {
                                document.body.classList.remove("p-overflow-hidden");
                            }}
                        >
                            <i className="pi pi-chevron-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
}

export default InstantSearchModalArticleDetails;
